import type { ComponentType } from "react";

export interface DocEntry {
	slug: string;
	frontmatter: {
		title: string;
		category: string;
		order: number;
		description?: string;
	};
	Component: ComponentType;
}

export interface DocCategory {
	name: string;
	articles: DocEntry[];
}

const modules = import.meta.glob<{
	default: ComponentType;
	frontmatter: { title: string; category: string; order: number; description?: string };
}>("/src/content/docs/*.mdx", { eager: true });

const allDocs: DocEntry[] = Object.entries(modules)
	.map(([path, mod]) => ({
		slug: path.replace("/src/content/docs/", "").replace(".mdx", ""),
		frontmatter: mod.frontmatter,
		Component: mod.default,
	}))
	.sort((a, b) => a.frontmatter.order - b.frontmatter.order);

// Group by category, preserving order
export const categories: DocCategory[] = (() => {
	const map = new Map<string, DocEntry[]>();
	for (const doc of allDocs) {
		const cat = doc.frontmatter.category;
		if (!map.has(cat)) map.set(cat, []);
		map.get(cat)!.push(doc);
	}
	return Array.from(map.entries()).map(([name, articles]) => ({ name, articles }));
})();

export const docs = allDocs;
